import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SignIn from "../pages/signin/page";
import { lazy } from "react";

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/signin',
    element: <SignIn />,
  },
  {
    path: '/getstarted',
    element: lazy(() => import('../pages/getstarted/page')),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
